import React, { useCallback, useEffect, useState } from 'react';
import { fetchJson } from '../../helpers/fetch.js';
import { Button } from '../bootstrap/index.jsx';
import { FaIcon } from '../common/Icons.jsx';
import { ColumnEditPortal } from './ColumnEdit.jsx';
import useReordeableColumns from './hooks/useColumnReorder.jsx';

import { datagrid_update_order_path } from '~/routes';

const separatorStyle = {
  borderBottom: '1px solid var(--ag-border-color)', 
  height: 'var(--ag-header-height)',
  padding: '0 var(--ag-widget-container-horizontal-padding)',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex'
}

const ColumnConfigurationPanel = ({ api, columnApi, context }) => {
  const [dialogColumn, setDialogColumn] = useState(null); // null => not visible, undefined => create, <field> => edit
  const [searchText, setSearchText] = useState("");

  const handleCreate = () => setDialogColumn(undefined);
  const handleEdit = (colField) => setDialogColumn(colField);
  const handleClose = () => setDialogColumn(null);

  const onReorder = useCallback((idOrderMap) => {
    fetchJson(
      datagrid_update_order_path({id: context.id, context_name: context.context_name, _options: true}),
      {body: JSON.stringify({columns_order: idOrderMap}), method: 'POST'}
    ).then(columns => {
      // If you need to process something, do it here.
    })
  }, [context, api]);

  const { columns, orderableColumns  } = useReordeableColumns(onReorder, handleEdit, api, searchText);
  const colDefs = columns.map(c => c.colDef);
  const EditDialog = ({ dialogColumn }) => {
    if (dialogColumn === null || !columns) return null;
    const column = dialogColumn !== undefined ? colDefs.find(c => c.field == dialogColumn) : undefined
    return (
      <ColumnEditPortal
        defaultValues={column ? column.cellRendererParams.original : {}}
        formOptions={context.columnFormOptions}
        onClose={handleClose}
        api={api}
        context={context}
        columnApi={columnApi}
        columns={colDefs}
        isCreate={column === undefined}
        title={ I18n.t(column ? 'edit_column': 'add_column') }
      />
    );
  };

  return (
    <div>
      <div className='mb-1' style={separatorStyle}>
        <Button size='sm' className='full-width' onClick={handleCreate}>
          <FaIcon type='plus' className='mr-1'/>{I18n.t('add_column')}
        </Button>
      </div>

      { columns.length > 10 &&
        <div className='mb-1' style={{...separatorStyle, marginTop: '-10px'}}>
          <input
            placeholder={`${I18n.t('search')}...`}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{width: '100%', padding: '6px 8px', border: '1px solid #ccc', borderRadius: '4px'}}
          />
        </div>
      }

      {orderableColumns}
      <EditDialog dialogColumn={dialogColumn}/>
    </div>
  );
};

export default ColumnConfigurationPanel;